import { Box } from '@everlywell/ui-kit';
import { SectionHeader } from 'components/SectionHeader';
import TestimonialBanner from 'components/TestimonialBanner';
import React from 'react';

interface MembersSatisfactionProps {
  title: string;
  headline: string;
  description: {
    description: string;
  };
  sectionImage: {
    url: string;
  };
  subHeadline?: string;
  backgroundColor?: string;
}

const MembersSatisfaction = ({
  title,
  headline,
  backgroundColor,
  sectionImage,
  description,
  subHeadline,
}: MembersSatisfactionProps) => (
  <Box as="section" width="100%" py={[16, 20]} px={['1rem', '1rem']}>
    <Box maxWidth="1440px" mx="auto">
    <SectionHeader eyebrow={title} title={headline} />
    <TestimonialBanner
      backgroundColor={backgroundColor}
      sectionImage={sectionImage}
      quote={description.description}
        attribution={subHeadline}
      />
    </Box>
  </Box>
);

export default MembersSatisfaction;
